import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import BaseLayout from './../../templates/base';
import Loading from './../../elements/loading';
import InmPagination from "../../elements/widgets/inmPagination";
import _ from 'lodash';
import {confirmAlert} from "react-confirm-alert";
import StrategiesAdd from './../../elements/strategies/widget/strategies_add';
import StrategiesSearch from './../../elements/strategies/widget/strategies_search';

class ProigualdadStrategies extends Component {
	render() {
		return (
			<StrategiesList {...this.props} />
		)
	}

	componentWillMount() {
		this.props.strategiesShow(this.props.strategies.pages.current);
	}
}

class StrategiesList extends Component {
	render() {
		let { strategies } = this.props;

		let su = _.find(strategies.permissions, (o) => {return o==='Update'});
		let sd = _.find(strategies.permissions, (o) => {return o==='Delete'});
		return (
			<div>
				{strategies.isFetching ? <Loading /> :
					<table className={`inm-table`}>
						<thead>
						<tr>
							<th>ID</th>
							<th>Código</th>
							<th>Nombre</th>
						</tr>
						</thead>
						<tbody>
						{_.map(strategies.list, (row, k) => {
							return (
								<tr key={k}>
									<td style={{width:'80px'}}>
										<div className="actions">
											{su ? <NavLink to={`/proigualdad/estrategias/editar/${row.id}`}><i className="fa fa-edit"></i></NavLink>:''}
											{sd ? <button onClick={() => this._getConfirm(row.id, row.name)}><i className="fa fa-trash-o"></i></button>:''}
										</div>
										{row.id}
									</td>
									<td>{row.code}</td>
									<td><strong>{row.name}</strong></td>
								</tr>
							)
						})}
						</tbody>
					</table>}
				{strategies.pages.total>20 &&
				<InmPagination key="strategies-pages"
				               current={strategies.pages.current}
				               total={strategies.pages.total}
				               nextPage={this._handlePageChange}/>}
			</div>
		)
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_handlePageChange(value) {
		const { strategies } = this.props;
		this.props.strategiesShow(value, strategies.filters);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar la estrategia "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.strategieDelete(id)
		})
	}
}

export default BaseLayout(ProigualdadStrategies, {
	title:"Estrategias Proigualdad",
	subnav: {
		icon: 'fa-flag-checkered',
		name: 'Proigualdad',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Buscar',
				element: <StrategiesSearch />
			},
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <StrategiesAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/strategies/index.jsx